module.exports = __webpack_public_path__ + "img/dropdown.0bcfcfaf.svg";